"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BDSTooltipMenuList = void 0;
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = tslib_1.__importStar(require("react"));
var BDSBackdrop_1 = require("../../../common/BDSBackdrop/BDSBackdrop");
var array_utils_1 = require("../../../../utils/array.utils");
var BDSTooltipMenuList_style_1 = require("./BDSTooltipMenuList.style");
function BDSTooltipMenuList(props) {
    var onDismiss = props.onDismiss, menuList = props.menuList, style = props.style, handleClick = props.handleClick, children = props.children, _a = props.position, position = _a === void 0 ? 'bottom' : _a, isOpen = props.isOpen;
    var childrenRef = react_1.useRef(document.createElement('div'));
    var selectBoxRef = react_1.useRef(document.createElement('div'));
    var _b = react_1.useState({}), childrenRefTargetPosition = _b[0], setChildrenRefTargetPosition = _b[1];
    var margin = 10;
    react_1.useEffect(function () {
        if (isOpen) {
            switch (position) {
                case 'top':
                    setChildrenRefTargetPosition({
                        top: childrenRef.current.getBoundingClientRect().top - selectBoxRef.current.clientHeight - margin,
                        left: childrenRef.current.getBoundingClientRect().left,
                    });
                    break;
                case 'left':
                    setChildrenRefTargetPosition({
                        top: childrenRef.current.getBoundingClientRect().top - selectBoxRef.current.clientHeight - margin,
                        left: childrenRef.current.getBoundingClientRect().left - selectBoxRef.current.clientWidth,
                    });
                    break;
                case 'right':
                    setChildrenRefTargetPosition({
                        top: childrenRef.current.getBoundingClientRect().top + childrenRef.current.clientHeight + margin,
                        left: childrenRef.current.getBoundingClientRect().left + childrenRef.current.clientWidth,
                    });
                    break;
                case 'bottom':
                default:
                    setChildrenRefTargetPosition({
                        top: childrenRef.current.getBoundingClientRect().top + childrenRef.current.clientHeight + margin,
                        left: childrenRef.current.getBoundingClientRect().left,
                    });
                    break;
            }
        }
    }, [isOpen]);
    return isOpen ? (jsx_runtime_1.jsxs(react_1.default.Fragment, { children: [jsx_runtime_1.jsx(BDSBackdrop_1.BDSBackdrop, { style: { zIndex: 1 }, handleClick: onDismiss }, void 0),
            jsx_runtime_1.jsx("div", tslib_1.__assign({ className: "material-dropdown", css: BDSTooltipMenuList_style_1.baseCss }, { children: jsx_runtime_1.jsxs("div", tslib_1.__assign({ className: "base-elem" }, { children: [jsx_runtime_1.jsx("div", tslib_1.__assign({ ref: childrenRef }, { children: children }), void 0),
                        jsx_runtime_1.jsx("div", tslib_1.__assign({ ref: selectBoxRef, className: "material-dropdown-select-box " + (menuList.length > 4 ? 'scroll' : '') + " " + position, style: tslib_1.__assign(tslib_1.__assign({}, style), childrenRefTargetPosition) }, { children: menuList.map(function (item, index) {
                                return (jsx_runtime_1.jsx("div", tslib_1.__assign({ className: "material-dropdown-list-item", onClick: function (e) {
                                        e.stopPropagation();
                                        handleClick(item.value, index, e);
                                    } }, { children: item.label }), array_utils_1.getUniqKey('position-dropdown-item', index)));
                            }) }), void 0)] }), void 0) }), void 0)] }, void 0)) : (jsx_runtime_1.jsx("div", { children: children }, void 0));
}
exports.BDSTooltipMenuList = BDSTooltipMenuList;
